import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "@/components/ui/pagination";

const VISIBLE_PAGES = 5;

const getPageRange = (currentPage, totalPages) => {
  let start = Math.max(1, currentPage - Math.floor(VISIBLE_PAGES / 2));
  let end = Math.min(totalPages, start + VISIBLE_PAGES - 1);

  if (end - start < VISIBLE_PAGES - 1) {
    start = Math.max(1, end - VISIBLE_PAGES + 1);
  }

  return Array.from({ length: end - start + 1 }, (_, i) => start + i);
};

/**
 * Reusable Pagination Component
 *
 * @param {number}   currentPage   - The active page number (1-based)
 * @param {number}   totalPages    - Total number of pages
 * @param {Function} onPageChange  - Callback fired with the new page number
 * @param {boolean}  disabled      - Disables all controls (e.g. while loading)
 */
const UsePagination = ({ currentPage, totalPages, onPageChange, disabled = false }) => {
  if (totalPages <= 1) return null;

  const pages = getPageRange(currentPage, totalPages);

  const goTo = (page) => {
    if (!disabled && page !== currentPage) {
      onPageChange(page);
    }
  };

  return (
    <Pagination>
      <PaginationContent>

        {/* Previous */}
        <PaginationItem>
          <PaginationPrevious
            onClick={() => goTo(currentPage - 1)}
            className={currentPage === 1 || disabled ? "pointer-events-none opacity-50" : "cursor-pointer"}
          />
        </PaginationItem>

        {/* Page Numbers */}
        {pages.map((p) => (
          <PaginationItem key={p}>
            <PaginationLink
              isActive={currentPage === p}
              onClick={() => goTo(p)}
              className={disabled ? "pointer-events-none opacity-50" : "cursor-pointer"}
            >
              {p}
            </PaginationLink>
          </PaginationItem>
        ))}

        {/* Next */}
        <PaginationItem>
          <PaginationNext
            onClick={() => goTo(currentPage + 1)}
            className={currentPage === totalPages || disabled ? "pointer-events-none opacity-50" : "cursor-pointer"}
          />
        </PaginationItem>

      </PaginationContent>
    </Pagination>
  );
};

export default UsePagination;